export class ConstantsHttpHeader {
    // pay attention: this strings will be used by proxy-component as well (do not change them)
    public static readonly XTeamsAppUserId: string = "X-TeamsApp-UserId";
    public static readonly XTeamsAppUserIV: string = "X-TeamsApp-UserIV";
    public static readonly XTeamsAppCpbx1GroupId: string = "X-TeamsApp-Cpbx1GroupId";
}
